import { isValidElement, ReactNode } from 'react';

export const checkIsTextAction = (textAction: ReactNode): Boolean => {
  if (!textAction || !isValidElement(textAction)) {
    return false;
  }

  /**
   * To type-narrow the ReactNode, we expect the `typeof textAction.type` to be an Object containing a `displayName` with the substring "`TextAction`".
   */

  const textActionType = textAction?.type;

  const isValidChild = !(
    typeof textActionType === 'string' ||
    (textActionType &&
      'displayName' in textActionType &&
      typeof textActionType.displayName === 'string' &&
      !textActionType.displayName.includes('TextAction'))
  );

  if (!isValidChild) {
    console.error('The textAction slot only accepts the TextAction component.');
  }

  return isValidChild;
};
